import { EyeOutlined } from "@ant-design/icons";
import { Dossier } from "@rumble-it/common-lib/types/models/Dossier.interface";
import { Button, LicensePlate } from "@rumbledirect/ui";
import { Space } from "antd";
import { format } from "date-fns";
import { Link } from "react-router-dom";

export const dashboardDossierColumns = [
  {
    title: "Kenteken",
    dataIndex: ["vehicle", "licensePlate", "identifier"],
    key: "licensePlate",
    render: (text: string) => <LicensePlate country="NL">{text}</LicensePlate>,
  },
  {
    title: "Bestuurder",
    dataIndex: "driver.person.fullName",
    key: "driver",
    render: (_: any, record: Dossier) => record.driver?.person?.fullName,
  },
  {
    title: "Lease / Verzekeraar",
    dataIndex: "insurerInfo",
    key: "lease",
    render: (_: any, record: Dossier) => {
      const insurerName = record.insurerName || record.insuranceCompany?.name;
      const leaseName = record.leaseCompany?.name;

      if (insurerName && leaseName) {
        return `${insurerName} / ${leaseName}`;
      }
      return insurerName || leaseName || "-";
    },
  },
  {
    title: "Hersteller",
    dataIndex: "servicePartners[0].name",
    key: "servicePartner",
    render: (_: any, record: Dossier) => record.servicePartners[0]?.name,
  },
  {
    title: "Aangemaakt",
    dataIndex: "createdAt",
    key: "createdAt",
    render: (v: string) => format(new Date(v), "dd-MM-yyyy HH:mm"),
  },
  {
    title: "Acties",
    dataIndex: "id",
    key: "actions",
    render: (id: string) => (
      <Space size="small">
        <Link to={`/claims/dossiers/${id}`}>
          <Button icon={<EyeOutlined />} variant="light" />
        </Link>
      </Space>
    ),
  },
];
